import { BreadcrumbsData } from '@systemeio/ui'
import { EmailPreview } from 'modules/mailing/email-statistics/components/email-preview'
import { MailingStatistic } from 'modules/mailing/email-statistics/components/mailing-statistic'
import { SummaryStatisticsTable } from 'modules/mailing/email-statistics/components/summary-statistics-table'
import { EmailStatisticsLoco } from 'modules/mailing/email-statistics/constants/email-statistics-loco'
import { useEmailPreview } from 'modules/mailing/email-statistics/hooks/use-email-preview'
import { useUserData } from 'modules/mailing/email-statistics/hooks/use-user-data'
import { MailingId } from 'modules/mailing/types/mailing-interface'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import React from 'react'
import BreadcrumbsDashboard from 'shared/components/breadcrumbs'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props'

// the page is reused in management section
const CampaignStepStatistics: NextPage<{ isAdminPage?: boolean }> = ({ isAdminPage = false }) => {
  const router = useRouter()
  const mailingId = Number(router.query.mailingId) as MailingId

  const { userData } = useUserData({ mailingId, isFetchAllowed: isAdminPage })

  const { t } = useLocoTranslation()

  const { emailPreviewData } = useEmailPreview({ emailId: mailingId })

  const breadcrumbsData: BreadcrumbsData[] = isAdminPage
    ? [
        {
          caption: t('dashboard.email_delivery_statistics.title'),
          href: '/management/emails-delivery-statistics',
          isStatic: true,
        },
        {
          caption: userData?.email || '',
          href: userData ? `/management/emails-delivery-statistics/${userData.id}` : '',
          isStatic: false,
        },
        { caption: emailPreviewData?.email.subject || '', isStatic: false },
      ]
    : [
        {
          caption: t('dashboard.email_statistics.breadcrumbs_title'),
          href: '/email-statistics',
          isStatic: true,
        },
        { caption: emailPreviewData?.email.subject || '', isStatic: false },
      ]

  return (
    <>
      <div className="mb-5 flex flex-row flex-wrap justify-between gap-2 md:flex-nowrap">
        <BreadcrumbsDashboard data={breadcrumbsData} isFetching={!emailPreviewData} />
        <EmailPreview email={emailPreviewData?.email} className={'ml-auto md:ml-0'} />
      </div>
      <SummaryStatisticsTable
        isLoading={!emailPreviewData}
        summaryStatistics={emailPreviewData?.stats}
      />
      <MailingStatistic mailingId={mailingId} isAdminPage={isAdminPage} />
    </>
  )
}

export const getServerSideProps = getBaseServerSideProps(
  EmailStatisticsLoco,
  'header.top_menu.emails',
)

export default CampaignStepStatistics
